// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZWbc1","col":"styles_col__1-wF1"};